module.exports = __webpack_public_path__ + "static/media/materia-bancaria.8d576d8d.jpg";